// select fields for alphabetical listing
var listingInput = document.getElementById( 'listing-input' );

if ( listingInput ) {
    listingInput.addEventListener( 'change', function ( e ) {
        var val = e.target.value ? e.target.value.toLowerCase() : null;
        // remove page number
        var href = window.location.href.replace( /\/page\/\=(.+)\&?/g, "" );
        href = href.replace( /\/listing\/.+\/?/g, "/listing/" + val );
        // change address in bar
        window.location.href = href;
    } )
}

function getCookie( cname ) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent( document.cookie );
    var ca = decodedCookie.split( ';' );
    for ( var i = 0; i < ca.length; i++ ) {
        var c = ca[ i ];
        while ( c.charAt( 0 ) == ' ' ) {
            c = c.substring( 1 );
        }
        if ( c.indexOf( name ) == 0 ) {
            return c.substring( name.length, c.length );
        }
    }
    return "";
}


function setCookie( cname, cvalue, exdays ) {
    var d = new Date();
    d.setTime( d.getTime() + ( exdays * 24 * 60 * 60 * 1000 ) );
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}


var expandedfilter = document.getElementById( 'expanded' );
var compactfilter = document.getElementById( 'compact' );
var peopleresults = document.querySelector( '.people-results' );

if ( getCookie( 'sizefilter' ) && 'compact' === getCookie( 'sizefilter' ) ) {
    
    compactfilter.classList.add( 'active' );
    compactfilter.setAttribute('aria-pressed', 'true');

    expandedfilter.classList.remove( 'active' );
    expandedfilter.setAttribute('aria-pressed', 'false');

    peopleresults.classList.add( 'compact' );

} else {

    expandedfilter.classList.add( 'active' );

}

expandedfilter.addEventListener( 'click', function () {

    expandedfilter.classList.add( 'active' );
    expandedfilter.setAttribute('aria-pressed', 'true');

    compactfilter.classList.remove( 'active' );
    compactfilter.setAttribute('aria-pressed', 'false');

    peopleresults.classList.remove( 'compact' );
    setCookie( 'sizefilter', 'expanded', 365 );

} );

compactfilter.addEventListener( 'click', function () {

    compactfilter.classList.add( 'active' );
    compactfilter.setAttribute('aria-pressed', 'true');

    expandedfilter.classList.remove( 'active' );
    expandedfilter.setAttribute('aria-pressed', 'false');

    peopleresults.classList.add( 'compact' );
    setCookie( 'sizefilter', 'compact', 365 );

} );